import React, {Component} from "react";
import Head from "../../components/Head";
import Subscribe from "../../components/Subscribe";
import {withTranslate} from "react-redux-multilingual"
import globalMiddleware from "../../hocs/globalMiddleware";
import {getHeader} from "../../config";
import axios from "axios";
import {Skeleton} from "react-loading-skeleton-placeholders"
import {baseLink} from "../../config"
import {setCurrentRoute} from "../../store/actions/globalActions";
import {connect} from "react-redux";
import Maintenance from "../../components/Maintenance";


class Privacy extends Component {
    state = {
        policies: null,
        error500: false
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.setCurrentRoute(window.location.href);

        axios.get(baseLink + "system/policies?type=0", {headers: getHeader()}).then(res => {
            if (res.data.Error.status === true) {
                console.log("response", res);
                this.setState({
                    policies: res.data.Response,
                });
            }
        }).catch(err => {
            console.log("error", err);
            this.setState({
                error500: true,
            });
        })
    }

    render() {

        const history = [
            {
                page: this.props.translate("home"),
                to: "/"
            }
        ]
        if (this.state.error500) {
            return (
                <Maintenance/>
            )
        }

        const policiesList = this.state.policies ?
            (
                <div>
                    <h1>{this.state.policies.name}</h1>
                    <p dangerouslySetInnerHTML={{__html: this.state.policies.condition}}/>
                </div>
            )
            :
            (<div>
                <Skeleton amount={4} bigBone={true}/>
                <br/>
                <Skeleton amount={4} bigBone={true}/>
                <br/>
                <Skeleton amount={4} bigBone={true}/>
            </div>);

        return (
            <div className="Privacy">
                <Head title={this.props.translate("privacy_title")} history={history}/>
                <section className="ftco-section doctors-list-all" id="doctors-list-all">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                {policiesList}
                            </div>
                        </div>
                    </div>
                </section>

                <Subscribe/>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(Privacy)));